<template>
  <div class="home">
    算法首页
  </div>
</template>

<script>

export default {
  name: "algorithm-index",
  data(){
   return {
     value:''
   } 
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>

</style>
